
import React, {Component} from 'react'
import EkoModal from '../elements/EkoModal'
import EkoInputTable from '../elements/EkoInputTable'
import {CSS} from '../../css/inputtable_modal.js'

export default class AddMedicalDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            saving: false,
            errors: this.defaultErrors(),
            tableData: {
                headers: [
                    {label: 'Tip', width: '10%'},
                    {label: 'GTIN (Küresel Ticari Ürün Numarası)', width: '11%'},
                    {label: 'BN (Parti Numarası)', width: '11%'},
                    {label: 'SN (Sıra Numarası)', width: '11%'},
                    {label: 'XD (Son Kullanma Tarihi)', width: '11%'},
                    {label: 'UNO (Ürün Numarası)', width: '11%'},
                    {label: 'LNO (Lot/Batch Numarası)', width: '11%'},
                    {label: 'SNO (Seri/Sıra Numarası)', width: '11%'},
                    {label: 'URT (Üretim Tarihi)', width: '11%'}
                ],
                rows: this.defaultRows()
            }
        }
    }

    defaultRows() {
        return [
            [
                {
                    type: 'select',
                    id: 'type',
                    optionValue: 'name',
                    selectedOptionValue: 'code',
                    optionId: 'code',
                    defaultText: 'SEÇ',
                    data: [
                        {code: 'ILAC', name: 'İlaç'},
                        {code: 'TIBBICIHAZ', name: 'Tıbbi Cihaz'}
                    ]
                },
                {type: 'text', id: 'gtin', vertical: true},
                {type: 'text', id: 'bn', vertical: true},
                {type: 'text', id: 'sn', vertical: true},
                {type: 'date', id: 'xd', vertical: true},
                {type: 'text', id: 'uno', vertical: true},
                {type: 'text', id: 'lno', vertical: true},
                {type: 'text', id: 'sno', vertical: true},
                {type: 'date', id: 'urt', vertical: true}
            ]
        ]
    }

    static defaultRowData() {
        return {
            type: '',
            gtin: '',
            bn: '',
            sn: '',
            xd: '',
            uno: '',
            lno: '',
            sno: '',
            urt: ''
        }
    }

    static getDefaultForm() {
        return {
            rows: [AddMedicalDetails.defaultRowData()]
        }
    }

    defaultErrors() {
        return {
            rows: [{
                type: false,
                gtin: false,
                bn: false,
                sn: false,
                xd: false,
                uno: false,
                lno: false,
                sno: false,
                urt: false
            }],
            footer: {}
        }
    }

    componentWillMount() {
        this.setState({formData: this.props.formData || AddMedicalDetails.getDefaultForm()});
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.formData) {
            let tableData = this.state.tableData
            if (nextProps.formData.rows && tableData.rows) {
                // Adjust rows length
                if (nextProps.formData.rows.length < tableData.rows.length) {
                    tableData.rows = this.defaultRows()
                }
                while (tableData.rows.length < nextProps.formData.rows.length) {
                    tableData.rows.push(this.defaultRows()[0])
                }
                
                nextProps.formData.rows.forEach((row, index) => {
                     this.updateRowDisability(tableData.rows[index], row.type);
                });
                this.setState({formData: nextProps.formData, tableData: tableData});
            }
        }
    }

    updateRowDisability(rowColumns, typeCode, rowToClear) {
        // Indices: 0:Type, 1:gtin, 2:bn, 3:sn, 4:xd, 5:uno, 6:lno, 7:sno, 8:urt
        const ilacFields = [1, 2, 3, 4]; // GTIN, BN, SN, XD
        const tibbiCihazFields = [5, 6, 7, 8]; // UNO, LNO, SNO, URT
        const fields = ['gtin', 'bn', 'sn', 'xd', 'uno', 'lno', 'sno', 'urt'];

        for (let i = 1; i <= 8; i++) {
             rowColumns[i].disabled = true;
             rowColumns[i].value = "";
        }

        if (rowToClear) {
            fields.forEach(f => rowToClear[f] = "");
        }

        if (typeCode === 'ILAC') {
            ilacFields.forEach(i => rowColumns[i].disabled = false);
        } else if (typeCode === 'TIBBICIHAZ') {
            tibbiCihazFields.forEach(i => rowColumns[i].disabled = false);
        }
    }

    onChangeRow(index, rowData, field) {
        let formData = this.state.formData
        let tableData = this.state.tableData
        let formErrors = this.state.errors
        
        // Clear error for the field
        if (formErrors.rows && formErrors.rows[index])
            formErrors.rows[index][field] = false

        if (field === 'type') {
            this.updateRowDisability(tableData.rows[index], rowData.type, rowData);
        }

        this.setState({formData: formData, errors: formErrors, tableData: tableData}, () => {
             if(this.props.onChange) this.props.onChange(formData);
        })
    }
    
    onRowAdd(){
        // Handle row addition if needed
    }
    
    onRowDelete(index, row) {
        let formData = this.state.formData;
        if(formData.rows.length > 1) {
             // Logic handled by EkoInputTable usually updates formData automatically if passed correctly? 
             // Actually EkoInputTable calls onRowDelete.
        }
    }

    onSave() {
        this.props.onSave(this.state.formData);
    }
    
    // Pass specific onChange to EkoInputTable to update local state logic if complicated, 
    // but here we just need to pass data back.
    // EkoInputTable usually handles value updates via onChangeRow props.

    render() {
        return (
            <EkoModal
                modalBodyStyle={{bottom: '8px'}}
                extraCss={CSS}
                showModal={this.props.showModal}
                title="İlaç / Tıbbi Cihaz Bilgileri"
                bsSize="xlg"
                onHide={() => {
                    if(this.props.onCancel) this.props.onCancel();
                }}
                spinner={false}
            >
                <EkoInputTable 
                    data={this.state.tableData} 
                    className="extramargin" 
                    formData={this.state.formData}
                    errors={this.state.errors}
                    onSave={this.onSave.bind(this)}
                    saving={this.state.saving}
                    onRowAdd={this.onRowAdd.bind(this)}
                    defaultRow={AddMedicalDetails.defaultRowData()}
                    buttonSaveLabel="Kaydet"
                    formId={"add_medical_details"}
                    buttonAddClass="btn-mleft"
                    onCancel={this.props.onCancel}
                    onChangeRow={this.onChangeRow.bind(this)}
                    onRowDelete={this.onRowDelete.bind(this)}
                />
            </EkoModal>
        )
    }
}
